<app-page-body>
  <!-- header -->
  <app-page-header [title]="this.pageVocabs + 'title'" [isForm]="true" [loading]="loading" (onBack)="onClose()"
    (onRefresh)="onReset()">
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">


      <!-- custom fields -->
      <section class="tw-mt-3">

        <fieldset>

          <legend>
            {{'common.customFields'|translate}}
          </legend>

          <div class="row ">

            <div class="md:tw-w-full ">

              <custom-field-selection-list [searchLabel]="pageVocabs+'searchInCustomFields'"
                (items)="getCustomFields($event)" [selectedItems]="input_model" [model]="model" >
              </custom-field-selection-list>

            </div>

          </div>

          <!-- <a class="btn btn-sm btn-danger" (click)="log()"> bezan</a> -->

        </fieldset>

      </section>



      <!-- form btns-->
      <section class="tw-my-15px">
        <div class="tw-flex tw-justify-end  tw-my-5">
          <div class="tw-flex tw-justify-end">

            <!-- cancel btn -->
            <a mat-ripple class="btn tw-mx-[5px]  button-shadow" [themeColor]="'cancel-btn'" (click)="onClose()">
              {{'common.cancel'|translate}}
            </a>

            <!-- submit btn -->
            <button type="button" (click)="onSubmit()" mat-ripple class="btn tw-w-[150px] tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise" [themeColor]="'btn'">

              <ng-container *ngIf="!loading">
                <span *ngIf="!formPageConfig.isEditMode"> {{'common.submit'|translate}}</span>
                <span *ngIf="formPageConfig.isEditMode">{{'common.edit'|translate}}</span>
              </ng-container>

              <!-- loading -->
              <ng-container *ngIf="loading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              </ng-container>

            </button>
          </div>
        </div>
      </section>



    </form>
  </div>


</app-page-body>
